var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCinemas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1718 3.50236C47.5688 3.38443 47.7951 2.96694 47.6772 2.56987C47.5593 2.1728 47.1418 1.94651 46.7447 2.06444L7.27954 13.7857H5.35658C3.108 13.7857 1.28516 15.6085 1.28516 17.8571V22.5892H48.7137V17.8571C48.7137 15.6085 46.8909 13.7857 44.6423 13.7857H12.548L47.1718 3.50236ZM48.7137 23.8392H1.28516V44.6428C1.28516 46.8914 3.108 48.7143 5.35658 48.7143H44.6423C46.8909 48.7143 48.7137 46.8914 48.7137 44.6428V23.8392ZM15.4912 44.039C19.1026 44.039 22.0302 41.1114 22.0302 37.5C22.0302 33.8885 19.1026 30.9609 15.4912 30.9609C11.8797 30.9609 8.9521 33.8885 8.9521 37.5C8.9521 41.1114 11.8797 44.039 15.4912 44.039ZM33.928 33.0598C33.5828 33.0598 33.303 33.3396 33.303 33.6848C33.303 34.03 33.5828 34.3098 33.928 34.3098H39.2852C39.6303 34.3098 39.9102 34.03 39.9102 33.6848C39.9102 33.3396 39.6303 33.0598 39.2852 33.0598H33.928ZM33.303 42.6134C33.303 42.2682 33.5828 41.9884 33.928 41.9884H39.2852C39.6303 41.9884 39.9102 42.2682 39.9102 42.6134C39.9102 42.9585 39.6303 43.2384 39.2852 43.2384H33.928C33.5828 43.2384 33.303 42.9585 33.303 42.6134Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinemas);
export default __webpack_public_path__ + "static/media/Cinemas.440c8cc10a2e68e9b1572d3339e79ec9.svg";
export { ForwardRef as ReactComponent };